// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2T3cc","title":"FrontImage_title__2Uzbu"};